import React from 'react';
import PropTypes from 'prop-types';
import { TopMenuItem } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';

import s from './styles.module.scss';

const TopMenu = ({ items, t }) => (
  <div className={s.title}>
    {items.map(({ text, ...otherProps }, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <TopMenuItem key={index} {...otherProps}>
        {t(text)}
      </TopMenuItem>
    ))}
  </div>
);

TopMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      exact: PropTypes.bool,
      to: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TopMenu);
